import { Http, Headers, RequestOptions, Response } from '@angular/http'
import { Injectable } from '@angular/core'

import { tokenModel } from './pages/login/token.model'
import { Boleto } from './pages/financeiro/boleto.model'
import { Usuario } from "./pages/login/usuario.model"
import { OperadorModel } from './pages/cad-oper/operador.model'
import { CategoriaModel } from './pages/administracao/categoria-atendimento/categoria.model'
import { VersaoModel } from './pages/administracao/versao/versao.model'

import 'rxjs/add/operator/toPromise'
import 'rxjs/add/operator/map';

import { Observable } from 'rxjs/Observable';
import { Promise } from 'q';
import { CategoriaAtendimentoComponent } from './pages/administracao/categoria-atendimento/categoria-atendimento.component';

@Injectable()
export class AcessoApiService {

  public urlAPI: string = "https://site.masterretail.com.br/"
  // public urlAPI: string = " http://internaltestapi.masterretail.com.br/"
 // public urlAPI: string = "http://localhost:64469/"

  constructor(private http: Http) {
  }

  //métodos referentes a tela de login


  //Método envia as credenciais para a API e retorna os dados de sessao do usuario
  public PostLogin(ID: string, PASS: string) {
    const params = JSON.stringify({ ID, PASS });
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.post(`${this.urlAPI}PostLogin`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //função de resetar senha da tela de login
  public resetarComCnpj(Id: string, CnpjComMascara: string) {

    var Cnpj = CnpjComMascara.replace(".", "");
    var Cnpj = Cnpj.replace("/", "");
    var Cnpj = Cnpj.replace("-", "");
    var Cnpj = Cnpj.replace(".", "");

    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ Id, Cnpj })

    return this.http.post(`${this.urlAPI}PostEnviaSenha`, params, {
      headers: headers
    }).map((response: Response) => response.json()[0])
  }

  //Fim dos métodos da tela de login


  //Métodos Financeiros

 //Método pega informações loja para carta de quitação

 public geCartaQuitacao(COD_LOJA: string): Observable<any> {

  const params = JSON.stringify({ COD_LOJA });
  const headers = new Headers({ 'Contet-Type': 'application/json' });

  return this.http.get(`${this.urlAPI}CartaQuitacao/${COD_LOJA}`, {
    headers: headers
  }).map(response => {
    return response.json();
  });

}





  //Método responsável de recuperar da API os Boletos com status de pendente no banco de dados
  public getBoletos(ID_OPER: string): Observable<Boleto> {
    const params = JSON.stringify({ ID_OPER });
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.post(`${this.urlAPI}PostBoletoPendente/`, params, {
      headers: headers
    }).map((response: Response) => <Boleto>response.json());

  }

  //Método responsável de recuperar da API os Boletos com status de quitado no banco de dados
  public getBoletosQuitados(ID_OPER: string): Observable<Boleto> {
    const params = JSON.stringify({ ID_OPER });
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.post(`${this.urlAPI}PostBoletoQuitado/`, params, {
      headers: headers
    }).map((response: Response) => <Boleto>response.json());
  }

  //recupera dados dos boletos solicitados pelo sistema
  public getDadosBoleto(ID_BLTO: number) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ ID_BLTO });

    return this.http.post(`${this.urlAPI}PostBoletoPDF`, params, {
      headers: headers
    }).map((response: Response) => response.json());
  }

  //Fim dos métodos Financeiros


  //Métodos Cadastro Operador

  //Valida se a loja possui algum operador cadastrado na loja logada
  public getCodOperExistente(cod_loja: string): Observable<OperadorModel> {
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.get(`${this.urlAPI}GetOperador/` + cod_loja)
      .map((response: Response) => <OperadorModel>response.json());
  }

  public getOperadorPorDocumento(cnpj: string, cod_loja: string): Observable<OperadorModel> {
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.get(`${this.urlAPI}GetOperadorPorDocumento/` + cnpj + '/' + cod_loja)
      .map((response: Response) => <OperadorModel>response.json());
  }

  //Envia dados do formulário de cadastro do operador
  public EnviaCadastroOperador(id_pessoa: string, id_oper: string, cod_loja: string, nome_loja: string, cod_oper: string, cpf: string,
    nome_oper: string, fantasia_nome: string, email: string, dtNascimento: string, senha: string, confirma_senha: string):
    Observable<OperadorModel> {
    const params = JSON.stringify({id_pessoa , id_oper , cod_loja, nome_loja, cod_oper, cpf, nome_oper, fantasia_nome, email, dtNascimento,
      senha, confirma_senha });
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.post(`${this.urlAPI}PostSalvaOperador/`, params, {
      headers: headers
    }).map((response: Response) => response.json());
  }


public validaCPF(cpf:  string){
const headers = new Headers({'Content-Type': 'application/json'});
const params = JSON.stringify({cpf})

return this.http.post(`${this.urlAPI}PostValidarCPF`, params, {
  headers: headers
}).map((response: Response) => response.json())

}


  // Fim Métodos Cadastro Operador


  //Métodos Categoria de Atendimento

  // Get que traz todas as Categorias de atendimento cadastradas no banco
  public getCategoriaAtendimento(): Observable<CategoriaModel> {
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.get(`${this.urlAPI}GetCategoria`)
      .map((response: Response) => <CategoriaModel>response.json());
  }

  //Recupera lista de niveis para o modal de inclusao de novas categorias
  public getListaNiveis(): Observable<CategoriaModel> {
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.get(`${this.urlAPI}GetListaNivel`).map((response: Response) => <CategoriaModel>response.json())
  }

  //Recupera lista de categoria pais para o modal de inclusao de novas categorias e edição
  public getListaPais(): Observable<CategoriaModel> {
    const headers = new Headers({ 'content-Type': 'application/json' })

    return this.http.get(`${this.urlAPI}GetListaCategPai`).map((response: Response) => <CategoriaModel>response.json())
  }

  //Envia os dados para a API salvar no banco referentes a uma nova categoria de atendimento
  public SalvarNovaCategoria(nivel_cat: number, num_cat: number, descricao_cat: string, ordem_cat: number, id_cat_pai: number): Observable<CategoriaModel> {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ nivel_cat, num_cat, descricao_cat, ordem_cat, id_cat_pai })

    return this.http.post(`${this.urlAPI}PostSalvaCategoria`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //Envia edição da categoria para a API para ser salva
  public EditarCategoria(id_cat: number, nivel_cat: number, num_cat: number, descricao_cat: string, ordem_cat: number, id_cat_pai: number): Observable<CategoriaModel> {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ id_cat, nivel_cat, num_cat, descricao_cat, ordem_cat, id_cat_pai })

    return this.http.post(`${this.urlAPI}PostSalvaCategoria`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //Envia o ID da categoria para ser excluido no banco de dados
  public excluirCategoria(id: number) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ id })

    return this.http.post(`${this.urlAPI}PostDeleteCatAtendimento`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //recebe os dados cadastrados no banco referentes ao ID da categoria selecionada
  public editarCategoria(Id: number) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ Id })

    return this.http.post(`${this.urlAPI}PostEditCategoria`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //Fim de Categoria de Atendimento


  //Tela de reset de senha


  //envia o código da loja que o reset vai ser feito
  public resetarSenha(cod_loja: string, cod_loja2: string) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ cod_loja, cod_loja2 })

    return this.http.post(`${this.urlAPI}PostResetSenha`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //fim reset de senha


  //Métodos de curriculos

  //Carrega todos os curriculos cadastrados
  public CarregarCurriculos(status: string) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ status })

    return this.http.post(`${this.urlAPI}PostCurriculos`, params, {
      headers: headers
    }).map((response: Response) => response.json())

  }

  //Puxa dados do curriculo para serem editados
  public ResgatarEdicaoCurriculo(cod_cand: number) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ cod_cand })

    return this.http.post(`${this.urlAPI}PostEditaCurriculo`, params, {
      headers: headers
    }).map((response: Response) => response.json())

  }

  //envia analise do candidato para a API
  public EnviarReAnalise(cod_cand: number, status: string, analise: string) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ cod_cand, status, analise })

    return this.http.post(`${this.urlAPI}PostSalvarAnaliseCurriculo`, params, {
      headers: headers
    }).map((response: Response) => response.json())

  }

  //Fim curriculos cadastrados

  //métodos Versão lojas

  //Carrega as versoes das lojas cadastradas
  public CarregarVersaoLoja() {
    const headers = new Headers({ 'content-Type': 'application/json' })

    return this.http.get(`${this.urlAPI}GetVersaoLoja`,
      { headers: headers }).map((response: Response) => <VersaoModel>response.json())
  }

  //Puxa a lista de sistemas cadastrados no modal de adicionar e editar da tela versao Loja
  public getListaSistemas(): Observable<VersaoModel> {
    const headers = new Headers({ 'Content-Type': 'application/json' });

    return this.http.get(`${this.urlAPI}GetListaSistema`).map((response: Response) => <VersaoModel>response.json())
  }

  //Puxa a lista de Versoes cadastrados no modal de adicionar e editar da tela versao Loja
  public getListaVersoes(): Observable<VersaoModel> {
    const headers = new Headers({ 'content-Type': 'application/json' })

    return this.http.get(`${this.urlAPI}GetListaVersao`).map((response: Response) => <VersaoModel>response.json())
  }

  //Envia os dados de edição e de Adição do modal de versao loja
  public EnviaDadosVersaoLoja(COD_LOJA: number, ID_SIS: number, VERSAO: string, QTDE_PDV: number,
    TIPO_INST: string, OBS_INST: string) {

    const params = JSON.stringify({ COD_LOJA, ID_SIS, VERSAO, QTDE_PDV, TIPO_INST, OBS_INST })
    const headers = new Headers({ 'content-Type': 'application/json' })

    return this.http.post(`${this.urlAPI}PostSalvaVersaoLoja`, params, {
      headers: headers
    }).map((response: Response) => response.json);
  }

  // Pelo ID da instalação realiza a exclusão do banco da versão loja
  public excluirVersao(ID_INST: number) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ ID_INST })

    return this.http.post(`${this.urlAPI}PostDeletaVersaoLoja`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //Recupera dados para a edição na tela de edição
  public editarVersao(ID_INST: number) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ ID_INST })

    return this.http.post(`${this.urlAPI}PostEditVersaoLoja`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //Envia dados da edição da versão loja
  public PostarEdicao(ID_INST: number, ID_SIS: number, NOME_SIS: string, COD_LOJA: number, VERSAO: string, QTDE_PDV: number, TIPO_INST: string, OBS_INST: string) {
    const headers = new Headers({ 'content-Type': 'application/json' })
    const params = JSON.stringify({ ID_INST, ID_SIS, NOME_SIS, COD_LOJA, VERSAO, QTDE_PDV, TIPO_INST, OBS_INST })

    return this.http.post(`${this.urlAPI}PostSalvaVersaoLoja`, params, {
      headers: headers
    }).map((response: Response) => response.json())
  }

  //fim Versao loja


  public uploadImage(formdata: any, idFoto: any) {
    let _url: string = `${this.urlAPI}PostFeed`;
    return this.http.post(_url, formdata).map((response: Response) => response.json())

  }
  public getFeed(){
    return this.http.get(`${this.urlAPI}GetFeed`).map((response : Response) => response.json())

  }


  public getMensagensImportantes(){
    return this.http.get(`${this.urlAPI}GetMensagens`).map((response : Response) => response.json())

  }

  public inserirNovaMensagem(titulo_not: string, url_not: string ){
    const headers = new Headers({ 'content-Type': 'application/json' })
    let id_not = null

    const params = JSON.stringify({ id_not, titulo_not, url_not })
    return this.http.post(`${this.urlAPI}PostEditaMensagem`, params,
    {headers:headers}).map((response: Response) => response.json())
  }

  public editarUltimaBlog(ID_FEED : string,MANCHETE_FEED: string, URL_FEED : string){
    const headers = new Headers({'content-Type': 'application/json'})
    const params = JSON.stringify({ ID_FEED, MANCHETE_FEED, URL_FEED })

    return this.http.post(`${this.urlAPI}PostFeedMensagem`, params, {
      headers:headers
    }).map((response: Response) => response.json())
  }

  public recuperarImagens(){
    return this.http.get(`${this.urlAPI}GetFotoFeed/nome`).map((response: Response) => response.json())

  }

  public alterarSenhaLoja(cod_loja: string, senha: string, novaSenha: string){
    const headers = new Headers({'content-Type': 'application/json'})
    const params = JSON.stringify({ cod_loja, senha, novaSenha })

    return this.http.post(`${this.urlAPI}PostAlteraSenha`,params,{
      headers:headers
    }).map((response: Response) => response.json())
  }

  public PostAlteraMensagem(id_not: number, url_not: string, titulo_not: string){
    const headers = new Headers({'content-Type': 'application/json'})
    const params = JSON.stringify({id_not, url_not, titulo_not})

    return this.http.post(`${this.urlAPI}PostAlteraMensagem`, params,{
      headers:headers
    }).map((resposta: Response) => resposta.json())


  }


  //metodos removidos por hora


  // public getToken(username: string, password: string): Observable<tokenModel> {
  //   let headers: Headers = new Headers
  //   headers.append('Content-Type', 'application/x-www-form-urlencoded');


  //   var data = "username=" + username + "&password=" + password + "&grant_type=password"

  //   return this.http.post('http://site.masterretail.com.br/token',
  //     data, new RequestOptions({ headers: headers })).map((response: any) => response.json())
  // }



  //   public validarAcesso(access_token: string): Observable<Usuario> {

  //     var headers = new Headers({ 'Content-Type': 'application/json' });
  //     headers.append('Authorization', 'Bearer ' + access_token)

  //     return this.http.get('http://site.masterretail.com.br/Get',
  //     {headers: headers}).map(res => res.json())



  //   }
}



// WEBPACK FOOTER //
// ./src/app/acessoApi.service.ts